/* eslint-disable no-loop-func */
import React, { useEffect, useRef, useState } from "react";
import { toast } from "../../components/ui/use-toast";
import * as XLSX from "xlsx";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import Spin from "../../components/Spin";
import {
  API,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import BootstrapTable from "react-bootstrap-table-next";
import { Button } from "../../components/ui/button";
import { Download, FileSpreadsheet } from "lucide-react";
import FileUpload from "../../components/FileUpload";
import { AnimatedTooltip } from "../../components/AnimatedTooltip";
import {
  dateFormatReader,
  ExcelDateFormat,
  getModuleNamingBySlug,
} from "../../lib/Misc";
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from "../../components/ui/dropdown-menu";
import CombineAssetHubImport from "../CombineAssetHubImport";
import moment from "moment";

const UploadVendor = ({
  fetchData,
  trustId,
  ButtonName,
  setLoading,
  organizationData,
}) => {
  const [showImport, setShowImport] = useState(false);
  const [showCombineImport, setShowCombineImport] = useState(false);
  const [files, setFiles] = useState([]);
  const [showExcelModal, setShowExcelModal] = useState(false);
  const [excelVendorData, setExcelVendorData] = useState();
  const [isImportLoading, setIsImportLoading] = useState(false);

  const handleDownload = async (sample) => {
    try {
      setLoading(true);
      let api = sample
        ? `${API.DOWNLOAD_VENDOR_TEMPLATE}?sample=${sample}&trust_id=${
            trustId ? trustId : ""
          }`
        : `${API.EXPORT_VENDOR}?trust_id=${trustId ? trustId : ""}`;
      const { data } = await get(api);
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("target", "_blank");
        a.setAttribute("download", file[file.length - 1] || "contractor.xls");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const handleCombineDownload = async () => {
    try {
      setLoading(true);
      let api = `${API.DOWNLOAD_COMBINE_ASSET_TEMPLATE}?trust_id=${
        trustId ? trustId : ""
      }`;

      const { data } = await get(api);
      const export_report_path = data?.data?.file;
      if (export_report_path) {
        var a = document.createElement("a");
        a.href = export_report_path;
        var file = export_report_path.split("/");
        a.setAttribute("download", file[file.length - 1] || "contractor.xls");
        document.body.appendChild(a);
        a.click();
        a.remove();
        setLoading(false);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  // const handleImportModal = async () => {
  //   setShowImport(!showImport);
  // };

  const handleCombineImportModal = async () => {
    setShowCombineImport(!showCombineImport);
  };

  const handleExcelClose = () => {
    setExcelSelectedRow([]);
    setShowExcelModal(false);
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleImportClose = () => {
    setShowImport(false);
    setIsImportLoading(false);
    setFiles([]);
  };

  const handleClose = () => {
    setFiles([]);
  };

  const ExcelVendorColumns = [
    {
      headerClasses: THClasses,
      dataField: "code",
      text: "Code",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "first_name",
      text: "First Name",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "last_name",
      text: (
        <div>
          <span className="required">*</span>Last Name
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Last Name is Required",
          };
        }
        return true;
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "phone",
      text: "Phone",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (newValue.split(" ").join("").length !== 10) {
            return {
              valid: false,
              message: "Please enter valid phone number",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (cell.split(" ").join("").length !== 10) {
            return `${TDClasses} text-red-500`;
          }
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "mobile",
      text: "Mobile",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (newValue.split(" ").join("").length !== 10) {
            return {
              valid: false,
              message: "Please enter valid mobile number",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (cell.split(" ").join("").length !== 10) {
            return `${TDClasses} text-red-500`;
          }
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "email",
      text: (
        <div>
          <span className="required">*</span>Email
        </div>
      ),
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue === "" || newValue === undefined || newValue === null) {
          return {
            valid: false,
            message: "Email is Required",
          };
        } else {
          if (newValue) {
            if (
              !newValue
                .toLowerCase()
                .match(
                  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                )
            ) {
              return {
                valid: false,
                message: "Please enter a valid email address",
              };
            }
          }

          return true;
        }
      },
      classes: (cell) => {
        if (cell) {
          if (
            !String(cell)
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              )
          ) {
            return `${TDClasses} text-red-500`;
          }
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "business_name",
      text: "Business Name",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(newValue)) {
            return {
              valid: false,
              message:
                "Business name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-), parentheses(), slashes(/) & spaces.", // Display the error message when validation fails
            };
          }
        }
        return true; // If valid, return true
      },

      // Optionally add CSS classes for invalid input (e.g., to highlight the field in red)
      classes: (cell) => {
        if (cell && !/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(cell)) {
          return `${TDClasses} text-red-500`; // Apply error styling
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "business_email",
      text: "Business Email",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (
            !newValue
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              )
          ) {
            return {
              valid: false,
              message: "Please enter a valid business email address",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (
            !String(cell)
              .toLowerCase()
              .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
              )
          ) {
            return `${TDClasses} text-red-500`;
          }
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "dob",
      text: "Date Of Birth",
      editCellClasses: "edit-cell-excel-class",
      formatter: (cell) => {
        let dateObj = cell;
        if (typeof cell === "string" && cell?.includes("-") && cell) {
          dateObj = cell?.split("-");
          if (dateObj[2]?.length > 2) {
            return `${dateObj[0]}-${dateObj[1]}-${dateObj[2]}`;
          } else {
            return `${dateObj[2]}-${dateObj[1]}-${dateObj[0]}`;
          }
        }
        if (typeof cell !== "object" && cell) {
          var utc_days = Math.floor(cell - 25569);
          var utc_value = utc_days * 86400;
          dateObj = new Date(utc_value * 1000);
        }
        if (cell) {
          return `${("0" + dateObj?.getUTCDate()).slice(-2)}-${(
            "0" +
            (dateObj?.getUTCMonth() + 1)
          ).slice(-2)}-${dateObj?.getUTCFullYear()}`;
        }
      },
      editor: {
        type: Type.DATE,
      },
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "abn",
      text: "ABN",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          let weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
          if (
            !String(newValue)
              .split(" ")
              .join("")
              .match(/^[\d]{11}$/)
          ) {
            return {
              valid: false,
              message: "Enter 11 Digit ABN Number",
            };
          }
          if (newValue.split(" ").join("").length === 11) {
            let newNumber = newValue.split(" ").join("");
            let sum = 0;
            weights.forEach((item, index) => {
              let digit = newNumber[index] - (index ? 0 : 1);
              sum += item * digit;
            });
            if (sum % 89 !== 0) {
              return {
                valid: false,
                message: "Enter Valid ABN Number",
              };
            }
          }
        }
      },
      classes: (cell) => {
        if (cell) {
          let weights = [10, 1, 3, 5, 7, 9, 11, 13, 15, 17, 19];
          if (cell.split(" ").join("").length !== 11) {
            return `${TDClasses} text-red-500`;
          }
          if (cell.split(" ").join("").length === 11) {
            let newNumber = cell.split(" ").join("");
            let sum = 0;
            weights.forEach((item, index) => {
              let digit = newNumber[index] - (index ? 0 : 1);
              sum += item * digit;
            });
            if (sum % 89 !== 0) {
              return `${TDClasses} text-red-500`;
            }
          }
        }
        return TDClasses;
      },
    },
    // {
    //   headerClasses: THClasses,
    //   dataField: "license_number",
    //   text: "Licence No.",
    //   editCellClasses: "edit-cell-excel-class",
    //   classes: TDClasses,
    // },
    {
      headerClasses: THClasses,
      dataField: "street",
      text: "Street",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(newValue)) {
            return {
              valid: false,
              message:
                "Street name can contain letters, numbers, ampersand(&), dot(.), comma(,), apostrophe('), hyphen(-), parentheses(), slashes(/) & spaces.", // Display the error message when validation fails
            };
          }
        }
        return true; // If valid, return true
      },

      // Optionally add CSS classes for invalid input (e.g., to highlight the field in red)
      classes: (cell) => {
        if (cell && !/^[^!@#%^$<>][a-zA-Z\s\d.,&'/()-]*$/.test(cell)) {
          return `${TDClasses} text-red-500`; // Apply error styling
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "suburb",
      text: "Suburb",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "state",
      text: "State",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "postal_code",
      text: "Postal Code",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (!newValue.match(/^[\d]{4}$/)) {
            return {
              valid: false,
              message: "Postal Code can contain 4 digit numbers.",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (!String(cell).match(/^[\d]{4}$/)) {
            return `${TDClasses} text-red-500`;
          }
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "bank_name",
      text: "Bank Name",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "account_name",
      text: "Account Name",
      editCellClasses: "edit-cell-excel-class",
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      dataField: "bsb",
      text: "BSB",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (String(newValue).match(/[\d]*$/)) {
            if (
              String(newValue).match("-")?.index === 3 ||
              !String(newValue).match("-")
            ) {
              if (String(newValue).match("-")) {
                if (newValue.split("-").join("").length > 6) {
                  return {
                    valid: false,
                    message: "Enter 6 Digit BSB Number",
                  };
                }
              } else {
                if (newValue.length > 6) {
                  return {
                    valid: false,
                    message: "Enter 6 Digit BSB Number",
                  };
                }
              }
            } else {
              return {
                valid: false,
                message: "Enter 6 Digit BSB Number",
              };
            }
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (String(cell).match(/[\d]*$/)) {
            if (
              String(cell).match("-")?.index === 3 ||
              !String(cell).match("-")
            ) {
              if (String(cell).match("-")) {
                if (String(cell).split("-").join("").length > 6) {
                  return `${TDClasses} text-red-500`;
                }
              } else {
                if (String(cell).length > 6) {
                  return `${TDClasses} text-red-500`;
                }
              }
            } else {
              return `${TDClasses} text-red-500`;
            }
          }
        }
        return TDClasses;
      },
    },
    {
      headerClasses: THClasses,
      dataField: "account_number",
      text: "Account Number",
      editCellClasses: "edit-cell-excel-class",
      validator: (newValue) => {
        if (newValue) {
          if (newValue.length > 9) {
            return {
              valid: false,
              message: "Please enter vaild 9 digit Account Number",
            };
          }
        }
        return true;
      },
      classes: (cell) => {
        if (cell) {
          if (cell.length > 9) {
            return `${TDClasses} text-red-500`;
          }
        }
        return TDClasses;
      },
    },
  ];

  const [excelSelectedRow, setExcelSelectedRow] = useState([]);

  let singleExcelSelectedRows = [];
  let allExcelSelectedRows = [];

  const excelSelectRow = {
    mode: "checkbox",
    clickToSelect: false,
    classes: "selection-row",
    nonSelectable: ["not-select"],
    selected: excelSelectedRow,
    nonSelectableClasses: "not-selected-class",
    onSelect: (row, isSelect, rowIndex, e) => {
      singleExcelSelectedRows = [...excelSelectedRow];
      if (isSelect) {
        singleExcelSelectedRows = [...excelSelectedRow, row?.key];
      } else {
        singleExcelSelectedRows.splice(excelSelectedRow.indexOf(row?.key), 1);
      }
      setExcelSelectedRow(singleExcelSelectedRows);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (let i = 0; i < rows.length; i++) {
          if (excelSelectedRow.includes(rows[i].key)) {
          } else {
            allExcelSelectedRows.push(rows[i].key);
          }
        }
      } else {
        for (let i = 0; i < rows.length; i++) {
          if (excelSelectedRow.includes(rows[i].key)) {
            excelSelectedRow.splice(excelSelectedRow.indexOf(rows[i].key), 1);
          }
        }
      }
      setExcelSelectedRow([...excelSelectedRow, ...allExcelSelectedRows]);
    },
  };

  const excelRef = useRef();

  function padWithLeadingZeros(num, totalLength) {
    return String(num).padStart(totalLength, "0");
  }

  function formatBSBNumber(num) {
    const numStr = num;
    if (numStr.length === 6) {
      return `${numStr.slice(0, 3)}-${numStr.slice(3)}`;
    } else {
      return "";
    }
  }

  const phoneFormat = (value) => {
    if (String(value)?.match(/\+61/)) {
      // let numberWithout61 = String(value)?.split("+61")[1];
      let numberData = String(value)?.split(" ")?.join("");

      if (numberData.length < 10) {
        numberData = `0${Number(numberData)}`; // Pad with leading zeros to make it 10 digits
      }

      return `${numberData.substring(0, 2)} ${numberData.substring(
        2,
        6,
      )} ${numberData.substring(6)}`;
    } else {
      if (value) {
        let numberData = String(value)?.split(" ")?.join("");
        if (numberData.length < 10) {
          numberData = `0${Number(numberData)}`; // Pad with leading zeros to make it 10 digits
        }
        return `${String(numberData).substring(0, 2)} ${String(
          numberData,
        ).substring(2, 6)} ${String(numberData).substring(6)}`;
      }
    }
  };

  const ExcelReader = () => {
    let f = files[0];
    const reader = new FileReader();
    let data = null;
    reader.onload = async (evt) => {
      // evt = on_file_select event
      /* Parse data */
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      data = await XLSX.utils.sheet_to_json(ws, { header: 1 });
      /* Update state */
      let selectItem = [];
      const businessExcelGenerator = (quantity) => {
        const items = [];
        if (
          String(data[0][0]).replace("*", "") !== "Code" ||
          String(data[0][1]).replace("*", "") !== "First Name" ||
          String(data[0][2]).replace("*", "") !== "Last Name" ||
          String(data[0][3]).replace("*", "") !== "Phone" ||
          String(data[0][4]).replace("*", "") !== "Mobile" ||
          String(data[0][5]).replace("*", "") !== "Email" ||
          String(data[0][6]).replace("*", "") !== "Business Name" ||
          String(data[0][7]).replace("*", "") !== "Business Email" ||
          String(data[0][8]).replace("*", "") !== "ABN" ||
          String(data[0][9]).replace("*", "") !== "Date Of Birth" ||
          String(data[0][10]).replace("*", "") !== "Street" ||
          String(data[0][11]).replace("*", "") !== "Suburb" ||
          String(data[0][12]).replace("*", "") !== "State" ||
          String(data[0][13]).replace("*", "") !== "Postal Code" ||
          String(data[0][14]).replace("*", "") !== "Bank Name" ||
          String(data[0][15]).replace("*", "") !== "Account Name" ||
          String(data[0][16]).replace("*", "") !== "BSB" ||
          String(data[0][17]).replace("*", "") !== "Account Number"
        ) {
          setShowExcelModal(false);
          setFiles();
          setIsImportLoading(false);
          toast({
            variant: "destructive",
            description:
              "Sorry, File is not in the given format, please download the latest format again",
            duration: 3000,
          });
        } else {
          for (let i = 1; i < quantity; i++) {
            const formatBSB = data[i][16]
              ? formatBSBNumber(
                  padWithLeadingZeros(
                    data[i][16].toString()?.includes("-")
                      ? Number(data[i][16].toString()?.split("-").join(""))
                      : Number(data[i][16]),
                    6,
                  ),
                )
              : "";

            let dob =
              typeof data[i][9] === "number"
                ? dateFormatReader(data[i][9])
                : data[i][9]?.split("-")[2] > 2
                  ? ExcelDateFormat(data[i][9])
                  : ExcelDateFormat(
                      data[i][9]?.split("-")?.reverse()?.join("-"),
                    );
            if (data[i].length > 0) {
              selectItem.push(i);
              items.push({
                key: i,
                code: data[i][0] ? data[i][0] : "",
                first_name: data[i][1] ? data[i][1] : "",
                last_name: data[i][2] ? data[i][2] : "",
                phone: data[i][3] ? phoneFormat(data[i][3]) : "",
                mobile: data[i][4] ? phoneFormat(data[i][4]) : "",
                email: data[i][5] ? data[i][5] : "",
                business_name: data[i][6] ? data[i][6] : "",
                business_email: data[i][7] ? data[i][7] : "",
                abn: data[i][8]
                  ? `${Number(String(data[i][8])?.split(" ")?.join(""))
                      .toLocaleString("en-US")
                      .replaceAll(",", " ")}`
                  : "",
                dob:
                  typeof data[i][9] === "string"
                    ? dob?.split("-")?.reverse()?.join("-")
                    : dob
                      ? dob
                      : "",
                street: data[i][10] ? data[i][10] : "",
                suburb: data[i][11] ? data[i][11] : "",
                state: data[i][12] ? data[i][12] : "",
                postal_code: data[i][13] ? data[i][13] : "",
                bank_name: data[i][14] ? data[i][14] : "",
                account_name: data[i][15] ? data[i][15] : "",
                bsb: formatBSB,
                account_number: data[i][17] ? data[i][17] : "",
              });
            }
          }
        }
        return items;
      };
      setExcelSelectedRow(selectItem);
      setExcelVendorData(businessExcelGenerator(data?.length));
    };
    reader.readAsBinaryString(f);
  };

  useEffect(() => {
    showExcelModal && ExcelReader();
    // eslint-disable-next-line
  }, [showExcelModal]);

  const handleExcelModal = () => {
    setShowExcelModal(true);
  };

  const handleUpload = async () => {
    if (excelSelectedRow.length > 1000) {
      toast({
        description: "Maximum limit to import vendors is 1000",
        duration: 3000,
      });
    } else {
      // if (files) {
      setShowExcelModal(true);
      const formData = new FormData();

      formData.append("trust_id", trustId);

      for (let i = 0; i < excelSelectedRow.length; i++) {
        let row = excelVendorData.find(
          (item) => item.key === excelSelectedRow[i],
        );
        let rowPhone = row.phone ? row.phone.split(" ") : "";
        let rowMobile = row.mobile ? row.mobile.split(" ") : "";
        row.phone = rowPhone ? rowPhone.join("") : "";
        row.mobile = rowMobile ? rowMobile.join("") : "";
        row.abn = row.abn ? row.abn.split(" ").join("") : "";
        // row.account_number = padWithLeadingZeros(row.account_number, 9);
        row.account_number =
          row.account_number === "000000000" || !row.account_number
            ? ""
            : padWithLeadingZeros(row.account_number, 9);
        row.bsb = row.bsb === "000-000" || !row.bsb ? "" : row.bsb;
        // row.bsb = row.bsb.split("-").join("");

        if (typeof row.dob !== "object") {
          if (row.dob) {
            let dobDateTemp = String(row.dob)?.split("T")[0]?.split("-");
            // row.dob = `${dobDateTemp[2]}-${dobDateTemp[1]}-${dobDateTemp[0]}`;
            if (dobDateTemp[2]?.length === 4) {
              row.dob = `${dobDateTemp[0]}-${dobDateTemp[1]}-${dobDateTemp[2]}`;
            } else {
              row.dob = `${dobDateTemp[2]}-${dobDateTemp[1]}-${dobDateTemp[0]}`;
            }
          }
        } else {
          if (row.dob) {
            row.dob = moment(row?.dob, "YYYY-MM-DD").format("DD-MM-YYYY");
          }
        }

        // formData.append(`vendors[${i}]`, JSON.stringify(row));
        Object.keys(row).forEach((key) => {
          formData.append(`vendors[${i}][${key}]`, row[key]);
        });
      }

      const config = { headers: { "Content-Type": "multipart/form-data" } };
      try {
        setIsImportLoading(true);
        const { data } = await fileUpload(
          `${API.IMPORT_VENDOR}`,
          formData,
          config,
        );
        setIsImportLoading(false);
        if (data) {
          setExcelSelectedRow([]);
          handleExcelClose();
          fetchData();
          handleImportClose();
          if (data?.data?.file) {
            const export_report_path = data?.data?.file;
            if (export_report_path) {
              var a = document.createElement("a");
              a.href = export_report_path;
              var file = export_report_path.split("/");
              a.setAttribute(
                "download",
                file[file.length - 1] || "error-subcontractor.xls",
              );
              a.setAttribute("target", "_blank");
              document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
              a.click();
              a.remove();
              setLoading(false);
            }
          }
        }
        return data?.data;
      } catch (error) {
        if (error?.response?.data?.errors) {
          if (error?.response?.data?.errors?.data?.file) {
            const export_report_path =
              error?.response?.data?.errors?.data?.file;
            if (export_report_path) {
              // eslint-disable-next-line no-redeclare
              var a = document.createElement("a");
              a.href = export_report_path;
              // eslint-disable-next-line no-redeclare
              var file = export_report_path.split("/");
              a.setAttribute(
                "download",
                file[file.length - 1] || "error-sub-contractor.xls",
              );
              a.setAttribute("target", "_blank");
              document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
              a.click();
              a.remove();
              setLoading(false);
            }
          }
          fetchData();
          setIsImportLoading(false);
        } else {
          setIsImportLoading(false);
        }
      }
      // }
    }
  };

  const handleExcelTableChange = async (
    type,
    { data, cellEdit: { rowId, dataField, newValue } },
  ) => {
    const getWithPromiseAll = async () => {
      let temp = await Promise.all(
        data.map(async (row) => {
          if (row?.key === rowId) {
            const newRow = { ...row };
            if (dataField === "account_number") {
              if (newValue) {
                newRow[dataField] = padWithLeadingZeros(Number(newValue), 9);
              } else {
                newRow[dataField] = "";
              }
            } else if (dataField === "mobile" || dataField === "phone") {
              newRow[dataField] = phoneFormat(newValue);
            } else if (dataField === "abn") {
              newRow[dataField] = newValue
                ? `${Number(newValue.split(" ").join(""))
                    .toLocaleString("en-US")
                    .replaceAll(",", " ")}`
                : "";
            } else if (dataField === "bsb") {
              if (String(newValue).match("-")) {
                newRow[dataField] =
                  padWithLeadingZeros(
                    Number(String(newValue).split("-").join("")),
                    6,
                  ).slice(0, 3) +
                  "-" +
                  padWithLeadingZeros(
                    Number(String(newValue).split("-").join("")),
                    6,
                  ).slice(3, 6);
              } else if (newValue) {
                newRow[dataField] =
                  padWithLeadingZeros(Number(newValue), 6).slice(0, 3) +
                  "-" +
                  padWithLeadingZeros(Number(newValue), 6).slice(3, 6);
              } else {
                newRow[dataField] = "";
              }
            } else {
              newRow[dataField] = newValue;
            }
            return newRow;
          }
          return row;
        }),
      );
      return temp;
    };
    const result = await getWithPromiseAll();
    setExcelVendorData(result);
  };
  return (
    <>
      <AnimatedTooltip title={"Export"}>
        <Button
          onClick={() => handleDownload(0)}
          className="flex gap-2 items-center"
        >
          Export <Download size={18} />
        </Button>
      </AnimatedTooltip>
      <div className="flex bg-webPrimary rounded-md">
        <AnimatedTooltip
          title={`Import ${getModuleNamingBySlug(
            organizationData?.organizationData,
            "vendors",
            "Vendor",
          )}`}
        >
          {/* <Button
            onClick={handleImportModal}
            className="bg-transparent flex items-center gap-1 px-2"
          >
            <FileSpreadsheet size={18} />
            {ButtonName}
          </Button> */}
          {/* <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button className="bg-transparent flex items-center gap-1 px-2">
                <FileSpreadsheet size={18} />
                {ButtonName}
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={handleImportModal}>
                Single Import
              </DropdownMenuItem>
              <DropdownMenuItem onClick={handleCombineImportModal}>
                <div>
                  <div className="flex flex-col">
                    <div>Combine Import</div>
                    <div className="text-xs text-webPrimary">
                      {`(${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor"
                      )}, ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "assets",
                        "Asset"
                      )}, ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "sub-assets",
                        "Sub Asest"
                      )})`}
                    </div>{" "}
                  </div>
                </div>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu> */}
          <Button
            onClick={handleCombineImportModal}
            className="bg-transparent flex items-center gap-1 px-2"
          >
            <FileSpreadsheet size={18} />
            {ButtonName}
          </Button>
        </AnimatedTooltip>

        {/* <Button
            onClick={() => handleDownload(1)}
            className="bg-transparent border-l border-white dark:border-black rounded-none px-2 rounded-se-md rounded-ee-md"
          >
            <Download size={18} />
          </Button> */}
        <AnimatedTooltip title={"Download Template"}>
          {/* <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button className="bg-transparent border-l border-white dark:border-black rounded-none px-2 rounded-se-md rounded-ee-md">
                <Download size={18} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={() => handleDownload(1)}>
                Single Template
              </DropdownMenuItem>
              <DropdownMenuItem onClick={() => handleCombineDownload()}>
                <div>
                  <div className="flex flex-col">
                    <div>Combine Template</div>
                    <div className="text-xs text-webPrimary">
                      {`(${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "vendors",
                        "Vendor"
                      )}, ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "assets",
                        "Asset"
                      )}, ${getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "sub-assets",
                        "Sub Asest"
                      )})`}
                    </div>{" "}
                  </div>
                </div>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu> */}

          <Button
            onClick={() => handleCombineDownload()}
            className="bg-transparent border-l border-white dark:border-black rounded-none px-2 rounded-se-md rounded-ee-md"
          >
            <Download size={18} />
          </Button>
        </AnimatedTooltip>
      </div>
      <ResponsiveDrawerForm
        description={""}
        title={`Import ${getModuleNamingBySlug(
          organizationData?.organizationData,
          "vendors",
          "Vendor",
        )}`}
        handleOpen={() => {}}
        handleClose={() => {
          handleClose();
        }}
        className={"sm:max-w-1/2"}
        open={showImport}
        buttonClassName={""}
        setOpen={setShowImport}
        mobileCancelHidden={true}
        write={true}
      >
        <>
          <FileUpload
            files={files}
            setFiles={setFiles}
            accept="application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, text/csv"
          />

          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button
              type="submit"
              onClick={(e) => {
                handleExcelModal();
              }}
              disabled={files?.length === 0}
            >
              Upload
            </Button>
            <Button
              className="reset ml-3"
              data-dismiss="modal"
              aria-label="Close"
              onClick={(e) => {
                handleImportClose();
              }}
              variant="secondary"
            >
              Cancel
            </Button>
          </div>
        </>
      </ResponsiveDrawerForm>
      <ResponsiveDrawerForm
        description={""}
        title={"Upload Excel"}
        handleOpen={() => {}}
        handleClose={() => {}}
        className={"max:min-w-screen"}
        open={showExcelModal}
        buttonClassName={""}
        setOpen={setShowExcelModal}
        write={true}
      >
        <div className="overflow-y-auto overflow-x-hidden max-h-[78vh] md:p-0 p-4">
          {isImportLoading && <Spin full expand={true} fullscreen={true} />}
          <div className="table-body-class">
            <BootstrapTable
              keyField="key"
              selectRow={excelSelectRow}
              ref={excelRef}
              remote={{ cellEdit: true }}
              data={excelVendorData ? excelVendorData : []}
              columns={ExcelVendorColumns}
              noDataIndication="No Data Found"
              cellEdit={cellEditFactory({
                mode: "click",
                blurToSave: true,
                timeToCloseMessage: 30000,
              })}
              onTableChange={handleExcelTableChange}
              rowClasses={TRClasses}
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>
          <div className="pt-4 border-t mt-4 flex items-center justify-between">
            <div>Selected Records: {excelSelectedRow?.length}</div>
            <Button
              onClick={handleUpload}
              data-toggle="modal"
              data-target="#business"
              disabled={excelSelectedRow.length === 0 ? true : false}
            >
              Import
            </Button>
          </div>
        </div>
      </ResponsiveDrawerForm>

      <ResponsiveDrawerForm
        description={""}
        title={`Import`}
        handleOpen={() => {}}
        handleClose={() => {
          handleClose();
        }}
        className={"sm:max-w-1/2"}
        open={showCombineImport}
        buttonClassName={""}
        setOpen={setShowCombineImport}
        mobileCancelHidden={true}
        write={true}
      >
        <>
          <CombineAssetHubImport
            fetchData={fetchData}
            setShowCombineImport={setShowCombineImport}
            trustId={trustId}
            setLoading={setLoading}
          />
        </>
      </ResponsiveDrawerForm>
    </>
  );
};

export default UploadVendor;
